import CustomReportStatus from '@/Enums/ReportBuilder/Status.enum';
import { ICustomReport } from '@/Interfaces/ReportBuilder/CustomReport.interface';
import StatusChip from '@/components/StatusChip';
import {
  ActiveStatusProps,
  InactiveStatusProps,
  PartialStatusProps,
  RunningStatusProps,
} from '@/components/StatusChip/StatusProps';
import { type ChipProps, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';

const statusChipPropMap: Record<CustomReportStatus, ChipProps> = {
  [CustomReportStatus.Success]: { ...ActiveStatusProps, label: CustomReportStatus.Success },
  [CustomReportStatus.Failed]: { ...InactiveStatusProps, label: CustomReportStatus.Failed },
  [CustomReportStatus.Running]: RunningStatusProps,
  [CustomReportStatus.Partial]: PartialStatusProps,
};

const GeneratedReportStatusChip = ({ value }: GridRenderCellParams<ICustomReport, CustomReportStatus>) => {
  const chipProps = useMemo(
    () => statusChipPropMap[value as CustomReportStatus] ?? { ...RunningStatusProps, label: 'Generating' },
    [value],
  );

  if (value === CustomReportStatus.Partial) {
    return (
      <Tooltip describeChild title='Report is ready to download, but some platforms returned no data.'>
        <span tabIndex={0}>
          <StatusChip {...chipProps} />
        </span>
      </Tooltip>
    );
  }

  return <StatusChip {...chipProps} />;
};

export default GeneratedReportStatusChip;
